import classNames from "classnames";
import { PropsWithChildren } from "react";
import styles from "./block.module.scss";

type Props = PropsWithChildren<{ className?: string }>;

export const Block = ({ children, className }: Props) => {
  return <div className={classNames(styles.block, className)}>{children}</div>;
};
